import { render, staticRenderFns } from "./communitybusiness.vue?vue&type=template&id=4710fcd5&scoped=true"
import script from "./communitybusiness.vue?vue&type=script&lang=js"
export * from "./communitybusiness.vue?vue&type=script&lang=js"
import style0 from "./communitybusiness.vue?vue&type=style&index=0&id=4710fcd5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4710fcd5",
  null
  
)

export default component.exports